export class Guild {
  constructor() {
    this.id = null;
    this.endpoint = null;
    this.join_infusion_minimum = null;
    this.join_infusion_minimum_bypass_by_request = null;
    this.join_infusion_minimum_bypass_by_invite = null;
    this.primary_reactor_id = null;
    this.entry_substation_id = null;
    this.creator = null;
    this.owner = null;
    this.name = null;
    this.description = null;
    this.tag = null;
    this.logo = null;
    this.socials = null;
    this.website = null;
    this.this_infrastructure = true;
    this.status = null;
    this.reactor_ratio = null;
    this.default_commission = null;
    this.validator = null;
  }
}